import { fork, takeLatest } from 'redux-saga/effects';
import * as Actions from './actions';
import * as E from './workers';

export function* watchGetWebhooks() {
  yield fork(E.ensureGetWebhooks);
  yield takeLatest(Actions.getWebhooks.TRIGGER, E.ensureGetWebhooks);
}

export function* watchGetWebhookById() {
  yield takeLatest(Actions.getWebhookById.TRIGGER, E.ensureGetWebhookById);
}

export function* watchCreateWebhook() {
  yield takeLatest(Actions.createWebhook.TRIGGER, E.ensureCreateWebhook);
}

export function* watchUpdateWebhook() {
  yield takeLatest(Actions.updateWebhook.TRIGGER, E.ensureUpdateWebhook);
}

export function* watchDeleteWebhook() {
  yield takeLatest(Actions.deleteWebhook.TRIGGER, E.ensureDeleteWebhook);
}

export function* watchTestWebhook() {
  yield takeLatest(Actions.testWebhook.TRIGGER, E.ensureTestWebhook);
}
